package one.healthium.fodmap

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import ifaandroid.apps.fodmap.composeapp.generated.resources.Res
import ifaandroid.apps.fodmap.composeapp.generated.resources.img_water_footer
import ifaandroid.apps.fodmap.composeapp.generated.resources.poppins_bold
import ifaandroid.apps.fodmap.composeapp.generated.resources.poppins_extrabold
import ifaandroid.apps.fodmap.composeapp.generated.resources.poppins_light
import ifaandroid.apps.fodmap.composeapp.generated.resources.poppins_medium
import ifaandroid.apps.fodmap.composeapp.generated.resources.poppins_regular
import ifaandroid.apps.fodmap.composeapp.generated.resources.poppins_semibold
import ifaandroid.apps.fodmap.composeapp.generated.resources.roboto_serif_bold
import ifaandroid.apps.fodmap.composeapp.generated.resources.roboto_serif_extrabold
import ifaandroid.apps.fodmap.composeapp.generated.resources.roboto_serif_medium
import ifaandroid.apps.fodmap.composeapp.generated.resources.roboto_serif_regular
import ifaandroid.apps.fodmap.composeapp.generated.resources.roboto_serif_semibold
import one.healthium.ui.compose.theme.AppTextStyle
import one.healthium.ui.compose.theme.AppThemeBase
import one.healthium.ui.compose.theme.Colors
import one.healthium.ui.compose.theme.Shapes
import one.healthium.ui.compose.theme.styles.DailyTaskItemStyle
import one.healthium.ui.compose.theme.styles.DailyTaskStyle
import one.healthium.ui.compose.theme.styles.LogWaterControlStyle
import one.healthium.ui.compose.theme.styles.ProfileStyle
import org.jetbrains.compose.resources.Font

@Composable
internal fun fodmap() = AppThemeBase(
    colors = Colors.fodmap,
    shapes = Shapes.carni,
    dailyTasksStyle = DailyTaskStyle(
        itemStyle = DailyTaskItemStyle.V2(
            containerColor = Colors.fodmap.primary,
            contentColor = Colors.fodmap.onPrimary,
        )
    ),
    textStyles = AppTextStyle(
        fontFamily = PoppinsFontFamily,
        fontFamilySecondary = PoppinsFontFamily,
        fontFamilyTertiary = RobotoSerifFontFamily,
        textField = TextStyle(
            fontFamily = PoppinsFontFamily,
            fontSize = 38.sp,
            fontWeight = FontWeight.Light,
        ),
    ),
    logWaterControlStyle = LogWaterControlStyle(
        footerImage = Res.drawable.img_water_footer,
    ),
    profileStyle = ProfileStyle(
        avatarContainerColor = Colors.fodmap.secondary,
        avatarContentColor = Colors.fodmap.onSecondary,
    )
)

private val PoppinsFontFamily
    @Composable get() = FontFamily(
        Font(Res.font.poppins_light, FontWeight.Light),
        Font(Res.font.poppins_regular, FontWeight.Normal),
        Font(Res.font.poppins_medium, FontWeight.Medium),
        Font(Res.font.poppins_semibold, FontWeight.SemiBold),
        Font(Res.font.poppins_bold, FontWeight.Bold),
        Font(Res.font.poppins_extrabold, FontWeight.ExtraBold),
    )

private val RobotoSerifFontFamily
    @Composable get() = FontFamily(
        Font(Res.font.roboto_serif_regular, FontWeight.Normal),
        Font(Res.font.roboto_serif_medium, FontWeight.Medium),
        Font(Res.font.roboto_serif_semibold, FontWeight.SemiBold),
        Font(Res.font.roboto_serif_bold, FontWeight.Bold),
        Font(Res.font.roboto_serif_extrabold, FontWeight.ExtraBold),
    )
